import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Library() {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{t('library.title')}</h1>
      <div className="bg-gray-800 rounded-xl p-5 text-gray-400">
        Coming soon — prompt library and templates.
      </div>
    </div>
  );
}
